import React from "react";
import Link from "next/link";
import { CALENDLY_URL } from "@/common/site.config";

function ServiceHeroSection({
  headlinePrimary,
  headlineHighWhite,
  descriptionPrimary,
  descriptionSecondary,
}) {
  return (
    <section className="relative overflow-hidden">
      <div className="landing-hero-glow opacity-80" aria-hidden />
      <div className="landing-hero-grid" aria-hidden />

      <div className="container relative z-10 max-w-7xl py-14 md:py-16 lg:py-20">
        <div className="flex max-w-4xl flex-col items-start text-left">
          <h1 className="syne-font text-3xl font-bold leading-[1.15] tracking-tight text-ink sm:text-4xl md:text-5xl lg:text-[3.5rem]">
            <span className="text-main">{headlinePrimary}</span>
            {headlineHighWhite ? (
              <>
                {" "}
                <br className="hidden sm:block" />
                {headlineHighWhite}
              </>
            ) : null}
          </h1>

          {descriptionPrimary ? (
            <p className="mt-5 max-w-2xl text-base leading-relaxed text-ink-muted md:text-lg">
              {descriptionPrimary}
            </p>
          ) : null}
          {descriptionSecondary ? (
            <p className="mt-3 max-w-2xl text-base leading-relaxed text-ink-muted">
              {descriptionSecondary}
            </p>
          ) : null}

          <div className="mt-8 flex flex-wrap items-center gap-3">
            <Link
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="landing-btn-primary"
            >
              Book a discovery call
            </Link>
            <Link href="/contact" className="landing-btn-secondary">
              Write to us
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ServiceHeroSection;
